export const USED_AS_SPA = "false" === 'true';
export const SENTRY_DSN = "https://5c9ccdb558354ea79c852e5184136e46@o61655.ingest.sentry.io/5261871" || '';

// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
const SPLIT_IO_API_KEY_STAGING = "n33vr9vfs09671pc90pgi7kvj8q7vvvfvjvd";
// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
const SPLIT_IO_API_KEY_PRODUCTION = "9a44abjpf5r66aq6r9o6426v9n2tg9ko9tah";
export default environment => {
  switch (environment) {
    case 'TEST':
    case 'LOCAL':
    case 'DEVELOPMENT':
    case 'STAGING':
      return {
        SPLIT_IO_API_KEY: SPLIT_IO_API_KEY_STAGING,
        urls: {
          CAMPUS_API: 'https://campus-api.datacamp-staging.com',
          GROUP_HUB_API: 'https://www.datacamp-staging.com/groups/graphql',
          MAIN_APP: 'https://www.datacamp-staging.com',
          PROJECTOR: 'https://projector.datacamp-staging.com'
        }
      };
    case 'PRODUCTION':
    default:
      return {
        SPLIT_IO_API_KEY: SPLIT_IO_API_KEY_PRODUCTION,
        urls: {
          CAMPUS_API: 'https://campus-api.datacamp.com',
          GROUP_HUB_API: 'https://www.datacamp.com/groups/graphql',
          MAIN_APP: 'https://www.datacamp.com',
          PROJECTOR: 'https://projector.datacamp.com'
        }
      };
  }
};